import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  markAsRead(params: ProviderIos.MarkAsRead.In) {
    return this.provider.markAsRead(params);
  }

  markAllAsRead() {
    return this.provider.markAllAsRead();
  }

  getMany() {
    return this.provider.getMany();
  }

  getPaginated(params: ProviderIos.GetPaginated.In) {
    return this.provider.getPaginated(params);
  }
}

export { Service };
